import React from "react"
import IconButton from "@mui/material/IconButton"
import Icon from "@mui/material/Icon"
import Grid from "@mui/material/Grid"
import Facebook from "@mui/icons-material/Facebook"
import Instagram from "@mui/icons-material/Instagram"
import Twitter from "@mui/icons-material/X"
import YouTube from "@mui/icons-material/YouTube"
import TikTokIcon from "../../assets/images/TikTokIcon"

type SocialAccount = {
  icon: React.ReactNode
  link: string
  label: string
}

const SOCIAL_ACCOUNTS: SocialAccount[] = [
  {
    icon: <Instagram />,
    link: "https://www.instagram.com/coastlineacademy",
    label: "Instagram Link",
  },
  { icon: <Twitter />, link: "https://x.com/drivecoastline", label: "X Link" },
  {
    icon: <Facebook />,
    link: "https://www.facebook.com/coastlineacademy",
    label: "Facebook Link",
  },
  {
    icon: <YouTube />,
    link: "https://www.youtube.com/channel/UCPruykTxAWpwh8i1GK-U1kA",
    label: "YouTube Link",
  },
  {
    icon: <TikTokIcon />,
    link: "https://www.tiktok.com/@coastline.academy",
    label: "TikTok Link",
  },
]

const SocialMediaIcons = () => (
  <Grid container spacing={1} style={{ justifyContent: "center" }}>
    {SOCIAL_ACCOUNTS.map((account, i) => (
      <Grid item key={i}>
        <IconButton
          href={account.link}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={account.label}
          size="large"
        >
          <Icon color="inherit">{account.icon}</Icon>
        </IconButton>
      </Grid>
    ))}
  </Grid>
)

export default SocialMediaIcons
